import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import mq from '../../utils/mediaQueries.js';
import { siteThemes, theme, isDefaultTheme, isGlobetrotter } from '../../utils/theming.js';

var GLOBETROTTER = siteThemes.GLOBETROTTER,
  DEFAULT = siteThemes.DEFAULT;
var borderColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-core-600)'), GLOBETROTTER, 'var(--color-almostblack)'));
var borderHoverColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-core-500)'), GLOBETROTTER, 'var(--color-quartz-500)'));
var borderWidth = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '-3px'), GLOBETROTTER, '-2px'));
var Tab = styled.button.withConfig({
  displayName: "Tabsstyle__Tab",
  componentId: "sc-17n5nd8-0"
})(["padding:var(--space-400) 0;transition:box-shadow var(--transition);white-space:nowrap;", " ", " ", " ", " &:hover{", "}&:focus-visible{outline:none;border-radius:0;box-shadow:inset 0 5px 0 0 ", ",inset 0 -5px 0 0 ", ";}"], isDefaultTheme(css(["padding-inline:var(--space-300);"])), function (_ref) {
  var $fullWidth = _ref.$fullWidth;
  return $fullWidth && css(["display:flex;flex-wrap:wrap;flex-grow:1;justify-content:center;margin-right:var(--space-500);&:last-child{margin-right:0%;}"]);
}, function (_ref2) {
  var $selected = _ref2.$selected,
    disabled = _ref2.disabled;
  return $selected && css(["box-shadow:inset 0 ", " 0 ", ";"], borderWidth, disabled ? 'var(--color-text-disabled)' : borderColor);
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && css(["color:var(--color-text-disabled);"]);
}, function (props) {
  return !props.$selected && !props.disabled && css(["box-shadow:inset 0 ", " 0 ", ";"], borderWidth, borderHoverColor);
}, borderHoverColor, borderHoverColor);
var TabLabel = styled.div.withConfig({
  displayName: "Tabsstyle__TabLabel",
  componentId: "sc-17n5nd8-1"
})(["width:100%;font:var(--font-button);text-transform:uppercase;", " ", " ", " ", ""], isDefaultTheme(css(["font-size:1.6rem;font-weight:400;transition:color var(--transition);", ""], function (_ref4) {
  var $selected = _ref4.$selected;
  return $selected && css(["text-shadow:0 0 .5px currentColor,0 0 .5px currentColor;"]);
})), isGlobetrotter(css(["letter-spacing:1.68px;color:var(--color-cta-button-primary);"])), function (_ref5) {
  var $lowercased = _ref5.$lowercased;
  return $lowercased && css(["text-transform:unset;"]);
}, function (_ref6) {
  var $disabled = _ref6.$disabled;
  return $disabled && css(["color:var(--color-text-disabled);"]);
});
var TabSubLabel = styled.div.withConfig({
  displayName: "Tabsstyle__TabSubLabel",
  componentId: "sc-17n5nd8-2"
})(["color:var(--color-text-subtle);margin-top:var(--space-100);", ""], function (_ref7) {
  var $disabled = _ref7.$disabled;
  return $disabled && css(["color:var(--color-text-disabled);"]);
});
var TabListContainer = styled.div.withConfig({
  displayName: "Tabsstyle__TabListContainer",
  componentId: "sc-17n5nd8-3"
})(["position:relative;"]);
var NavButton = styled.div.withConfig({
  displayName: "Tabsstyle__NavButton",
  componentId: "sc-17n5nd8-4"
})(["display:none;align-items:center;justify-content:center;background-color:var(--color-black);opacity:80%;min-height:32px;min-width:32px;cursor:pointer;border-radius:50%;position:absolute;left:calc(-1 * var(--space-500) - 32px);z-index:100;top:calc(50% - 16px);color:var(--color-white);@media (max-width:1300px){left:-16px;}", " &:hover{opacity:100%;}", ""], function (_ref8) {
  var $right = _ref8.$right;
  return $right && css(["transform:rotate(180deg);left:unset;right:calc(-1 * var(--space-500) - 32px);@media (max-width:1300px){right:-16px;left:unset;}"]);
}, mq.s(css(["display:flex;"])));
var TabListScrollContainer = styled.div.withConfig({
  displayName: "Tabsstyle__TabListScrollContainer",
  componentId: "sc-17n5nd8-5"
})(["overflow-x:auto;scroll-behavior:smooth;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"]);
var TabList = styled.div.withConfig({
  displayName: "Tabsstyle__TabList",
  componentId: "sc-17n5nd8-6"
})(["display:inline-flex;gap:var(--space-200);border-bottom:solid 1px var(--color-grey-300);", " ", ""], isGlobetrotter(css(["gap:var(--space-500);"])), function (_ref9) {
  var $fullWidth = _ref9.$fullWidth;
  return $fullWidth && css(["gap:0;display:flex;"]);
});
var TabPanel = styled.div.withConfig({
  displayName: "Tabsstyle__TabPanel",
  componentId: "sc-17n5nd8-7"
})([""]);

export { NavButton, Tab, TabLabel, TabList, TabListContainer, TabListScrollContainer, TabPanel, TabSubLabel };
//# sourceMappingURL=Tabs.style.js.map
